export const COLOR = {
  bg: '#F9FAFF',
  'light-grey': '#EDEFF9',
  'white-blue': '#DBE4FF',
  danger: '#EF4337',
  warning: '#FFD337',
  success: '#43A452',
  primary: {
    primary: '#0E7EE4',
    white: '#FFFFFF',
    darkGrey: '#788796',
    black: '#212519',
  },
  secondary: {
    blackBlue: '#052745',
    darkBlue: '#065BA9',
    midBlue: '#55A6F2',
    lightBlue: '#8BC6FF',
    bleachedBlue: '#C0E8FF',
    blackGreen: '#063E40',
    darkGreen: '#2E8285',
    green: '#14B8B4',
    midGreen: '#14B0BC',
    lightGreen: '#59D1CE',
    bleachedGreen: '#CBF0EF',
  },
  gradients: {
    'alto-blue': 'linear-gradient(to right, #0E7EE4, #55A6F2)',
    'alto-green': 'linear-gradient(to right, #14B8B4, #59D1CE)',
  },
  heatmap: {
    cold: '#C0E2FF',
  },
  purple: "#AB5EED",
  bluegradient:
    "radial-gradient(141.42% 462.96% at 0% 0%, rgba(14, 126, 228, 0.10) 0%, rgba(14, 126, 228, 0.00) 100%)",
  greengradient:
    "radial-gradient(141.42% 462.13% at 0% 0%, rgba(20, 184, 180, 0.10) 0%, rgba(20, 184, 180, 0.00) 100%)",
  yellowgradient:
    "radial-gradient(141.42% 626.94% at 0% 0%, rgba(250, 210, 145, 0.20) 0%, rgba(250, 210, 145, 0.00) 98.96%)",
  orangegradient:
    "radial-gradient(141.42% 462.13% at 0% 0%, rgba(255, 122, 0, 0.10) 0%, rgba(255, 122, 0, 0.00) 100%)",
  redgradient:
    "radial-gradient(141.42% 626.94% at 0% 0%, rgba(234, 102, 63, 0.20) 0%, rgba(234, 102, 63, 0.00) 100%);",
};

export const SHADOW = {
  cardborder: "1px 3px 20px 0px rgba(154, 170, 207, 0.10)",
  smallCardborder: "1px 0px 19px 0px rgba(14, 126, 228, 0.10)",
  button: "1px 2px 6px 0px rgba(190, 196, 198, 0.20)",
};

export const antdTheme = {
  components: {
    Select: {
      activeBorderColor: COLOR.primary.primary,
      hoverBorderColor: COLOR.primary.primary,
      activeOutlineColor: COLOR.primary.white,
      multipleItemBg: COLOR.heatmap.cold,
      optionSelectedFontWeight: 400,
      optionFontSize: 10,
      optionHeight: 15,
      colorBorder: COLOR['light-grey'],
    },
  },
  token: {
    fontFamily: 'Inter',
    fontSize: 10,
    borderRadius: 10,
  }
}
